import * as yup from "yup";

function diffIntervalDate(date1, date2) {
  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays > 30;
}

const filterValidation = yup.object().shape({
  protocol: yup.string(),
  skills: yup
    .array()
    .of(
      yup.object().shape({
        value: yup.string().required("Required"),
      })
    )
    .nullable(),
  agent: yup
    .array()
    .of(
      yup.object().shape({
        value: yup.string().required("Required"),
        label: yup.string().required("Required"),
      })
    )
    .nullable(),
  client: yup.string().test("client", "Minimum 3 characters", (value) => {
    if (value) {
      return value.trim().length > 3;
    }
    return true;
  }),
  personal_information: yup.object().shape({
    value: yup.string(),
    types: yup.array().when("value", {
      is: (value) => value,
      then: yup.array().of(yup.string()).required("Required"),
    }),
  }),
  date: yup
    .array()
    .of(yup.date())
    .test("date", "Select an interval less than or equal to 30 days", (value) => {
      if (value && value.length === 2) {
        return !diffIntervalDate(value[0], value[1]);
      }
      return true;
    })
    .required("Required"),
});

export default filterValidation;
